export default {
	open: 'Avaa',
	remove: 'Poista',

	illustration: 'Tekoälyllä tuotettu visualisointi',

	error: 'Virhe',
	'error/token error': 'Virhe tunnisteen varmentamisessa.',

	'general/floor': '{{floor}}. kerros',
	'general/floor_abbr': '{{floor}}. krs',
	'general/toggle/yes': 'Kyllä',
	'general/toggle/no': 'Ei',

	'colors/transparent': 'Läpinäkyvä',
	'colors/white': 'Valkoinen',
	'colors/green': 'Vihreä',
	'colors/blue': 'Sininen',
	'colors/greyWithWhite': 'Harmaa/valkoinen',
	'colors/greyWithBlack': 'Harmaa/musta',
	'colors/dark': 'Tumma',
	'colors/lightBlue': 'Vaalean sininen',
	'colors/yellow': 'Keltainen',
	'colors/orange': 'Oranssi',

	'page/layout_large-and-small--small-on-left': 'Pieni kuva vasemmalla',

	collection: 'Kokoelma',
	'collection/Save': 'Tallenna',
	'collection/Confirm remove': 'Haluatko varmasti poistaa kokoelman?\n\nHuomio: Kokoelman osoite toimii vielä poistamisen jälkeen.',
	'colleciton/New collection': 'Uusi kokoelma',
	'collection/Collections': 'Kokoelmat',
	'collection/Brochure': 'Sisältää yhden esitteen',
	'collection/Brochure_plural': 'Sisältää {{count}} esitettä',
	'collection/Missing brochures': 'Jokin valituista esitteistä on poistettu.',
	'collection/Add to collection': 'Lisää kokoelmaan',
	'collection/Add/remove from collection': 'Lisää tai poista kokoelmasta',
	'collection/Remove from collection': 'Poista kokoelmasta',
	'collection/Add master to collection': 'Lisää master kokoelmaan',
	'collection/Remove master from collection': 'Poista master kokoelmasta',
	'collection/Brochures': 'Esitteet',
	'collection/Recipients': 'Vastaanottajat',
	'collection/Recipient/Remove': 'Poista',
	'collection/Recipient/Add new recipient': 'Lisää uusi vastaanottaja',
	'collection/Collection': 'Lomake',
	'collection/Collection name': 'Kokoelman nimi',
	'collection/Name': 'Nimi',
	'collection/Name/Placeholder': 'Etunimi Sukunimi',
	'collection/Email': 'Sähköpostiosoite',
	'collection/Email/Placeholder': 'asiakas@asiakas.fi',
	'collection/Message': 'Viesti',
	'collection/Message/Placeholder': 'Kokoelman mukana lähtevä viesti...',
	'collection/Signature': 'Allekirjoitus',
	'collection/Signature/Placeholder': 'Kokoelman mukana lähtevä allekirjoitus',
	'collection/Cc': 'Lähetä minulle kopio viestistä',
	'collection/Start a new collection': 'Luo uusi kokoelma',
	'collection/Start a new collection/Confirm': 'Haluatko varmasti aloittaa uuden kokoelman?',
	'collection/Sending': 'Lähetetään...',
	'collection/Send': 'Lähetä',
	'collection/Send/Confirm': 'Kokoelma lähetetty onnistuneesti!\n\nHaluatko aloittaa uuden kokoelman?',


	'contacts/Your contacts': 'Yhteyshenkilösi',
	'contacts/Your contact': 'Yhteyshenkilösi',
	'contacts/Your contacts/Customer service': 'Spondan asiakaspalvelukeskus 020 355 6677 arkisin klo 8.30–16 | sponda.fi',
	'contacts/Your contacts/body': 'SPONDA OY on yksi Suomen suurimmista kiinteistösijoitusyhtiöistä. Omistamme, vuokraamme ja kehitämme toi- mistotiloja, liiketiloja ja kauppakeskuksia Suomen suurimmissa kaupungeissa. Olemme kiinteistöalan suunnannäyt- täjä, luotettava toimitilakumppani ja vastuullinen kaupunkikeskustojen kehittäjä. Toimitilamme sijaitsevat kaupun- kien parhailla paikoilla hyvien kulkuyhteyksien äärellä. Rakennamme viihtyisiä ja nykyaikaisia kohtaamispaikkoja, jotka tukevat uusia työskentelymuotoja. Tehtävämme on kehittää toimintaympäristöjä, jotka luovat edellytykset asiakkaidemme menestykselle.',
	'contacts/Why sponda': 'Miksi Sponda toimitilakumppaniksi',
	'contacts/Why sponda/1/title': 'LAAJASTA KIINTEISTÖVALIKOIMASTAMME',
	'contacts/Why sponda/1/body': 'löydät tilatarpeidenne muuttuessa joustavasti uusia, sopivia tilavaihtoehtoja.',
	'contacts/Why sponda/2/title': 'PARHAISIIN SIJAINTIPAIKKOIHIN',
	'contacts/Why sponda/2/body': 'keskittyvästä kiinteistöportfoliostamme löytyy runsaasti laadukkaita ratkaisuja yrityksenne toimitilatarpeisiin.',
	'contacts/Why sponda/3/title': 'KATTAVIEN YMPÄRISTÖOHJELMIEMME',
	'contacts/Why sponda/3/body': 'avulla voimme yhdessä kehittää toimitilakiinteistönne energiatehokkuutta ja ympäristömyönteisyyttä.',
	'contacts/Why sponda/4/title': 'MONIPUOLISET, LAADUKKAAT PALVELUT',
	'contacts/Why sponda/4/body': 'helpottavat toimintaanne kiinteistöissämme ja tukevat liiketoimintanne menestystä.',
	'contacts/Why sponda/5/title': 'KOKEMUS JA AMMATTITAITO',
	'contacts/Why sponda/5/body': 'auttavat meitä tunnistamaan tiloihin liittyvät tarpeenne ja tarjoamaan niihin soveltuvat, liiketoimintaanne tukevat toimitilat.',

	'a11y/Accessibility': 'Saavutettavuus',
	'a11y/Renovation year': 'Peruskorjaus-&nbsp;/ saneerausvuosi',
	'a11y/Energy efficiency class': 'Energia&shy;luokka',
	'a11y/Energy efficiency program': 'Energiatehokkuus&shy;ohjelma',
	'a11y/Environment certificate': 'Ympäristö&shy;sertifikaatti',

	'responsibility/Page title': 'Vastuullisuus',

	'app/Other language': 'en',
	'app/Other language name': 'In English',
	'app/Loading': 'Ladataan...',
	'app/sort/abc': 'Aakkosjärjestys (Osoite)',
	'app/sort/abc_name': 'Aakkosjärjestys (Nimi)',
	'app/sort/abc_building_name': 'Aakkosjärjestys (Kohteen nimi)',
	'app/sort/area': 'Huoneala',

	'header/Back to browse': 'Takaisin kohdelistaukseen',
	'header/Back to building': 'Takaisin kohteeseen',
	'header/Back': 'Takaisin',

	'space-type/office': 'Toimistotila',
	'space-type/production': 'Tuotantotila',
	'space-type/store': 'Liiketila',
	'space-type/storage': 'Varastotila',
	'space-type/meeting': 'Kokoustila',
	'space-type/teach': 'Koulutustila',
	'space-type/logistic': 'Logistiikkatila',

	'layout/fullPage': 'Yksi kuva',
	'layout/halfAndHalf': 'Teksti ja kuva',
	'layout/verticalLargeAndSmall': 'Allekkainen kuva ja teksti',
	'layout/horizontalSmallAndLarge': 'Vierekkäinen teksti ja kuva',
	'layout/horizontalLargeAndSmall': 'Vierekkäinen kuva ja teksti',
	'layout/LargeAndSmall': 'Iso ja pieni kuva',
	'layout/contacts': 'Yhteyshenkilösi',
	'layout/contact': 'Yhteyshenkilösi (muokattava)',
	'layout/accessibility': 'Saavutettavuus',
	'layout/responsibility': 'Vastuullisuus',
	'layout/largeMap': 'Iso kartta',
	'layout/building': 'Etusivu',
	'layout/space': 'Tila',
	'layout/spaceDetails': 'Tila: Kuva ja teksti vasemmalla',
	'layout/spaceDetails2': 'Tila: Teksti ja kuva vasemmalla',
	'layout/spaceDetails3': 'Tila: Teksti ja kuva ison kuvan alla',

	'controls/type/image': 'Kuva',
	'controls/type/text': 'Teksti',
	'controls/type/pictogram': 'Piktogrammi',
	'controls/type/page': 'Sivu',
	'controls/type/contact': 'Yhteyshenkilö',
	'controls/type/responsibility': 'Vastuullisuus',

	'controls/settings': 'Sisällön asetukset',
	'controls/close': 'Sulje',
	'controls/cancel/Cancel selection': 'Peruuta valinta',
	'controls/cancel/Cancel changes': 'Peruuta muutokset',
	'controls/save/Use selected images': 'Käytä valittuja kuvia',
	'controls/save/Save changes': 'Tallenna muutokset',
	'controls/common/settings/background color': 'Sisältöalueen taustaväri',
	'controls/common/settings/layout': 'Sisältöalueen asettelu',
	'controls/type/map': 'Kartta',
	'controls/map/info/default': 'Kartan aputeksti',
	'controls/text/Save unsaved changes': 'Tallennetaanko muutokset?',
	'controls/text/settings/column count': 'Palstojen määrä',
	'controls/text/settings/layout/default': 'Oletus',
	'controls/text/settings/layout/centered': 'Keskitetty',
	'controls/text/settings/layout/top-centered': 'Keskitetty ylös',
	'controls/text/settings/layout/bottom-centered': 'Keskitetty alas',
	'controls/text/settings/layout/left-centered': 'Keskitetty vasemmalle',
	'controls/text/info/default': 'Voit vaihtaa tekstin muotoilua maalaamalla tekstin ja klikkaamalla toivottua muotoilua.',
	'controls/text/content/label': 'Tuo sisältö tietokannasta',
	'controls/text/content/choose': 'Valitse',
	'controls/text/content/building': 'Kohde',
	'controls/text/content/space': 'Tila',
	'controls/text/content/ingress': 'Ingressi',
	'controls/text/content/description': 'Kuvaus',
	'controls/text/content/additional_info': 'Kohteen lisätiedot',
	'controls/text/content/environment_certificate_text': 'Ympäristosertifikaattiteksti',
	'controls/text/content/building_services_additional_info': 'Kiinteistön palvelut',
	'controls/text/content/building_service_parking_additional_info': 'Pysäköinti',
	'controls/text/content/local_services_additional_info': 'Alueen palvelut',
	'controls/text/content/accessibility_additional_info': 'Saavutettavuus',
	'controls/text/content/No space selected': 'Sivulle ei ole valittu tilaa',
	'controls/text/editor/Placeholder': 'Tähän voi syöttää tekstiä...',
	'controls/text/format/block/label': 'Kappaleen muotoilu',
	'controls/text/format/inline/label': 'Valinnan muotoilu',
	'controls/text/format/h1': 'Otsikko',
	'controls/text/format/h2': 'Nosto',
	'controls/text/format/h3': 'Ingressi',
	'controls/text/format/h4': 'Alaotsikko',
	'controls/text/format/bold': 'Lihavoitu',
	'controls/text/format/italic': 'Kursivoitu',
	'controls/text/format/body': 'Leipäteksti',
	'controls/pictogram/info/default': 'Piktogrammin aputeksti',
	'controls/pictogram/title/label': 'Piktogrammien otsikko',
	'controls/pictogram/value/label': 'Piktogrammin kuvaus',
	'controls/pictogram/select items': 'Valitse piktogrammit',
	'controls/image/info/default': 'Voit asemoida kuvan valitsemalla sen ensiksi listalta.',
	'controls/image/info/align': `Kuvan kohdistus, skaalaus ja koko eivät välttämättä toimi aina yhdessä.
		Tarkista lopputulos PDF:stä sekä verkkoesitteestä.`,
	'controls/image/info/select': 'Voit valita yhden tai useamman lisättävän kuvan.',
	'controls/image/language/label': 'Valitse kuvan näkyvyys kieliversiolla',
	'controls/image/language/all': 'Kaikilla kieliversiolla',
	'controls/image/info/maxlength': `

		PDF-esittellä voidaan näyttää vain neljä kuvaa, mutta verkkoesitteellä näytetään enemmän.`,
	'controls/image/image/name': 'Nimi',
	'controls/image/image/description': 'Kuvaus',
	'controls/image/scale/label': 'Skaalaus ({{scale}})',
	'controls/image/position/label': 'Kohdistus ({{x}} / {{y}})',
	'controls/image/size/label': 'Koko',
	'controls/image/size/cover': 'Peitä alue',
	'controls/image/size/contain': 'Sovita alueelle',
	'controls/image/tag/label': 'Havainnekuva',
	'controls/image/tag/alternativeLabel': 'Vaihtoehtoinen havainnekuva teksti',
	'controls/image/tag/description': 'Näytä "Havainnekuva" kuvassa',
	'controls/image/remove': 'Poista',
	'controls/image/remove/confirm': 'Haluatko varmasti poistaa valitun kuvan sivulta? Toiminto on peruuttamaton.',
	'controls/image/select images': 'Valitse kuvat',
	'controls/contact/choose': 'Valitse yhteyshenkilö',

	'controls/listitem/empty': 'Ei valintoja',
	'controls/listitem/select': 'Valitse',
	'controls/listitem/selected': '(%s% / %t% valittu)',
	'controls/listitem/title': 'Valitse',
	'controls/listitem/cancel': 'Peruuta',
	'controls/listitem/confirm': 'Käytä valintoja',
	'controls/listitem/remove': 'Haluatko varmasti poistaa valinnan?',
	'controls/listitem/no items': 'Ei vaihtoehtoja',

	'controls/responsibility/items': 'Vastuullisuusaiheet',
	'controls/responsibility/logos': 'Sertifikaatit',
	'controls/responsibility/select items': 'Valitse aiheet',
	'controls/responsibility/select logos': 'Valitse sertifikaatit',
	'controls/responsibility/select images': 'Valitse kuvat',
	'controls/responsibility/column options': 'Sarakemäärä',
	'controls/responsibility/sidebar options': 'Sivupalkin sisältö',
	'controls/responsibility/sidebar text': 'Teksti',
	'controls/responsibility/sidebar image': 'Kuva',
	'controls/responsibility/sidebar none': 'Ei sivupalkkia',

	'header/filters/Contact': 'Yhteyshenkilö',
	'header/filters/City': 'Kaupunki',
	'header/filters/SpaceType': 'Tilatyyppi',
	'header/filters/Place': 'Alue',
	'header/filters/Location': 'Sijainti',
	'header/filters/Area': 'Huoneala',
	'header/filters/Search placeholder': 'Hae kohteella, osoitteella tai yhteyshenkilöllä',
	'header/user/Settings': 'Asetukset',
	'header/user/Log out': 'Kirjaudu ulos',
	'header/brochure/Show pages': 'Näytä sivut',
	'header/brochure/Page settings': 'Sivun asetukset',
	'header/brochure/Generate PDF': 'Luo PDF',
	'header/brochure/Web brochure': 'Verkkoesite',
	'header/brochure/Share brochure': 'Jaa esite',

	'browse/Add brochures to collection': 'Lisää esitteitä kokoelmaan',
	'browse/Loading brochures': 'Ladataan esitteitä...',
	'browse/No brochures': 'Kohteella ei ole esitteitä',
	'browse/Loading buildings': 'Ladataan kohteita...',
	'browse/Listing all buildings': 'Näytetään kaikki kohteet',
	'browse/Building count': '{{count}} kohde',
	'browse/Building count_plural': '{{count}} kohdetta',
	'browse/Only show buildings with free spaces': 'Näytä vain kohteet joilla on vapaita tiloja',
	'browse/Only show free spaces': 'Näytä vain vapaita tiloja',
	'browse/Building/Tile/Space count': '{{count}} tila',
	'browse/Building/Tile/Space count_plural': '{{count}} tilaa',
	'browse/Building/List/Spaces/Filtered spaces': '+{{count}} tila joka ei osu suodattimiin',
	'browse/Building/List/Spaces/Filtered spaces_plural': '+{{count}} tilaa jotka eivät osu suodattimiin',
	'browse/Building/List/Floors': 'Kerroksia',
	'browse/Building/List/Area': 'Huoneala',
	'browse/Building/List/Construction year': 'Rakennusvuosi',
	'browse/Building/List/Space types': 'Tilatyypit',
	'browse/Building/List/Contact': 'Yhteyshenkilö',
	'browse/Building/List/Contact_plural': 'Yhteyshenkilöt',
	'browse/Building/List/Floor': 'Kerros',
	'browse/Building/List/Space': 'Tila',
	'browse/Building/List/Free': 'Vapaa',
	'browse/Building/List/Yes': 'Kyllä',
	'browse/Building/List/No': 'Ei',

	'building/prompt/Brochure name': 'Esitteen nimi:',
	'building/prompt/Brochure type': 'Esitteen tyyppi:',
	'building/prompt/Brochure space': 'Esitteen tila:',
	'building/prompt/Clone name': 'Kopion nimi:',
	'building/prompt/(Copy)': '(Kopio)',
	'building/confirm/Delete': 'Haluatko varmasti poistaa tämän esitteen?',
	'building/images/browse images': 'Selaa kohteen kuvia',
	'building/images/filter': 'Suodata kuvia:',
	'building/images/Close images': 'Sulje kuvat',
	'building/images/modal/title': 'Kohteen kuvat',
	'building/images/modal/close': 'Sulje',
	'building/images/print': 'Tulosta',
	'building/spaces/Floor': 'Kerros',
	'building/spaces/Space': 'Tila',
	'building/spaces/Available': 'Vapaana',
	'building/spaces/Area': 'Huoneala',
	'building/spaces/Yes': 'Kyllä',
	'building/spaces/No': 'Ei',
	'building/spaces/indicative price': 'Indikatiivinen neliöhinta',
	'building/details/Floors': 'Kerroksia',
	'building/details/Area': 'Huoneala',
	'building/details/Space types': 'Tilatyypit',
	'building/details/Contact': 'Yhteyshenkilö',
	'building/details/Contact_plural': 'Yhteyshenkilöt',
	'building/Brochures': 'Esitteet',
	'building/Create new brochure': 'Luo uusi esite',
	'building/Brochures/Latest first': 'Uusin ensin',
	'building/Brochures/Page': '{{count}} sivu',
	'building/Brochures/Page_plural': '{{count}} sivua',
	'building/Brochures/Share': 'Jaa',
	'building/Brochures/Copy': 'Kopioi',
	'building/brochures/clone/title': 'Kopioi esite',
	'building/Brochures/View': 'Avaa verkkoesite',
	'building/Brochures/Remove': 'Poista',
	'building/Brochures/Modified': 'Muokattu',
	'building/Brochures/Created': 'Luotu',
	'building/Brochures/Select spaces': 'Valitse kopioitavat tilasivut',
	'building/Brochures/Contacts': 'Yhteyshenkilöt',

	'brochure/Confirm slot change with unsaved changes': 'Sisältöalueella on tallentamattomia muutoksia.\n\nMuutokset menetetään jos vaihdat muokattavaa sisältöaluetta.\n\nHaluatko jatkaa tallentamatta?',
	'brochure/Read only': 'Lukutila käytössä. Sinulla ei ole oikeuksia muokata tätä esitettä.',
	'brochure/Page list/Remove selected page': 'Poista valittu sivu',
	'brochure/Page list/Remove selected page_plural': 'Poista valitut sivut ({{count}} kpl)',
	'brochure/Page list/Remove selected page/Confirm': 'Haluatko varmasti poistaa valitun sivun?',
	'brochure/Page list/Remove selected page/Confirm_plural': 'Haluatko varmasti poistaa valitut sivut? ({{count}} kpl)',
	'brochure/Page list/Add new page': 'Lisää uusi sivu',
	'brochure/Page select/Choose template': 'Valitse sivupohja lisättävälle sivulle',
	'brochure/Page select/Close': 'Sulje',
	'brochure/Page select/Add page': 'Lisää sivu',
	'brochure/Controls/Page/Attached space': 'Sivuun liitetty tila',
	'brochure/Controls/Page/Not selected': 'Ei valittu',
	'brochure/Controls/Page/Layout': 'Sivun asettelu',
	'brochure/Controls/Page/Default layout': 'Oletus',
	'brochure/Controls/Page/Building pattern': 'Näytetäänkö sivulla talokuvio',
	'brochure/Controls/Page/Sponda logo': 'Näytetäänkö sivulla Spondan logo',
	'brochure/Controls/Page/Move in logo': 'Näytetäänkö sivulla Move In -logo',
	'brochure/Controls/Page/slot type': 'Voit vaihtaa sivun palstojen tyyppiä raahaamalla tyypin sivupalkista palstan päälle.',
	'brochure/Share/title': 'Jaa esite',
	'brochure/Share/Web brochure/label': 'Verkkoesite',
	'brochure/Share/Web brochure/address': 'Verkkoesitteen osoite',
	'brochure/PDF/generate': 'Luo PDF',
	'brochure/PDF/generate/open': 'Avaa PDF',
	'brochure/PDF/generate/generated': 'PDF luotu',
	'brochure/PDF/generate/modal/title': 'Luo PDF',
	'brochure/PDF/generate/modal/cancel': 'Peruuta',
	'brochure/PDF/generate/modal/close': 'Sulje',
	'brochure/PDF/generate/modal/generate': 'Luo PDF',
	'brochure/PDF/generate/modal/generating': 'Luodaan PDF...',
	'brochure/PDF/generate/modal/quality': 'Kuvien laatu',
	'brochure/PDF/generate/modal/quality/original': 'Kuvan alkuperäinen laatu (Hitaampi lataus)',
	'brochure/PDF/generate/modal/quality/large': 'Tavallinen laatu',
	'brochure/PDF/generate/modal/quality/small': 'Heikko laatu (Nopeampi lataus)',
	'brochure/PDF/copy to clipboard': 'Kopioi PDF:n osoite leikepöydälle',
	'brochure/PDF/copied to clipboard': 'Osoite kopioitu leikepöydälle',
	'brochure/Type/master': 'Master-esite',
	'brochure/Type/default': 'Oletusesite',
	'brochure/Type/normal': 'Normaaliesite',
	'controls/page/remove page': 'Poista sivu',
	'controls/page/remove confirm': 'Haluatko varmasti poistaa sivun?\n\nToiminto on peruuttamaton.',


	'login/Log in': 'Kirjaudu sisään',
	'login/Logging in': 'Kirjaudutaan sisään...',
	'login/username': 'Käyttäjätunnus',
	'login/username/placeholder': 'sinä@sponda.fi',
	'login/password': 'Salasana',
	'login/error': 'Väärä käyttäjätunnus tai salasana!',
	'login/back to login': 'Takaisin kirjautumiseen',
	'login/new password': 'Luo uusi salasana',
	'login/Order new password': 'Tilaa uusi salasana',
	'login/forgot password': 'Unohtunut salasana',
	'login/Forgotten password': 'Unohtunut salasana',
	'login/Request a new password': 'Tilaa salasanan vaihto',
	'login/Requesting a new password...': 'Pyydetään salasanan vaihtoa...',
	'login/Password link in email': 'Linkki salasanan vaihtoon on lähetetty sähköpostiisi.',
	'login/Password changed successfully!': 'Salasana vaihdettu onnistuneesti!',
	'login/New password': 'Syötä uusi salasana',
	'login/Set new password': 'Aseta uusi salasana',
	'login/Setting new password...': 'Asetetaan uutta salasanaa...',
	'login/password indicator 0': ' ',
	'login/password indicator 1': 'Liian heikko',
	'login/password indicator 2': 'Välttävä',
	'login/password indicator 3': 'Hyvä',
}
